import { trackStructuredEvent } from 'js/helpers/google-tag-manager';

const track = (data: Record<'property' | 'label', string>) =>
  trackStructuredEvent({
    category: 'nearme_page',
    action: 'click',
    ...data,
  });

export const trackSearchLocation = (location: string) =>
  track({
    property: 'search_submitted',
    label: location,
  });

export const trackVenueSelection = (venueId: string) =>
  track({
    property: 'venue_selection',
    label: venueId,
  });

export const trackCitySelection = (city: string) =>
  track({
    property: 'city_selection',
    label: city,
  });
